import { observer } from 'mobx-react';
import { L, T } from '../../../../../../Translations';
import { ProductLicenseOverview } from '../../../Types';
import { ReactNode } from 'react';

interface Props {
  license: ProductLicenseOverview;
}

function GetLicenseDate(license: ProductLicenseOverview) {
  return {
    count: license.daysRemaining,
    span: (content: ReactNode) => <span className="text-amber-700">{content}</span>,
    date: <L localizeable={license.endOn} format="short-month-day-year" />,
  };
}

function LicenseStatusEndOnDisplay({ license }: Props) {
  const dateProps = GetLicenseDate(license);

  switch (license.licenseKind) {
    case 'past':
      return <T kind="Expired <date/> (<span>{{count}} days ago</span>)" {...dateProps} />;
    case 'active':
      return <T kind="Expires <date/> (<span>{{count}} days remaining</span>)" {...dateProps} />;
    case 'future':
      return (
        <T
          kind="Expires <date/>"
          date={<L localizeable={license.endOn} format="short-month-day-year" />}
        />
      );
  }
}

export default observer(LicenseStatusEndOnDisplay);
